export enum TrustedDevicePurgeJobStatus {
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
